import {createApi} from '@reduxjs/toolkit/query/react'
import {baseQuery} from '../base-query'

/**
 * Master skills catalog — owned by Ollyboard (one-way flow Olly → platform).
 * The UI only READS the catalog; skills are created in Olly's Skills Library
 * and pushed to the backend, never minted here.
 */
export interface SkillCatalogItem {
  id: string
  name: string
  category?: string
  status: 'Active' | 'Archived'
}

export interface SkillsCatalogResponse {
  skills: SkillCatalogItem[]
}

export const skillsApi = createApi({
  reducerPath: 'SkillsApi',
  tagTypes: ['SkillsCatalog'],
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getSkillsCatalog: builder.query<SkillsCatalogResponse, {status?: 'Active' | 'Archived'} | void>(
      {
        providesTags: ['SkillsCatalog'],
        query: (params) => ({
          url: `/skills`,
          method: 'GET',
          params: {status: params?.status ?? 'Active'},
        }),
        // Near-static reference data — keep it cached for an hour
        keepUnusedDataFor: 3600,
      },
    ),
  }),
})

export const {useGetSkillsCatalogQuery} = skillsApi
